import clsx from 'clsx';

import styles from './TextButton.module.scss';

function TextButton({ children, className, normal, result, disable, ...rest }) {
    return (
        <button
            {...rest}
            className={clsx(
                styles.button,
                normal && styles.normal,
                result === 'right' && styles.right,
                result === 'wrong' && styles.wrong,
                disable && styles.disable,
                className,
            )}
            disabled={!!disable}
        >
            {children}
        </button>
    );
}

export default TextButton;
